import "jquery-ui/ui/core";
import "jquery-ui/ui/widgets/tooltip";

$(function () {
    /*
    $("span.with-tooltip").each(function () {
        const content =
            '<a class="with-info" data-tags="optimize" title="teest"><span class="have-underline">' +
            $(this).html() +
            "</span></a>";
        $(this).replaceWith(function () {
            return content;
        });
    });
    */
    // method 2
    $(".allow-tooltip-tag a, [href='#with-tooltip']").each(function () {
        var title = $(this).attr('title');
        const content =
            '<a class="with-info" data-tags="'+title+'"><span class="have-underline">' +
            $(this).html() +
            "</span></a>";
        $(this).replaceWith(function () {
            return content;
        });
    });

    // $(".with-info").tooltip();

    // $("body").on("mouseover", ".with-info", function () {
    //     console.log("test");
    // });
    // $('span.with-tooltip').tooltip({
    //     tooltipClass: "ui-tooltip1",
    //     content: function (callback) {
    //         var element = $(this);
    //         if (element.is("span.with-tooltip")) {
    //             var text = element.attr('data-title');
    //             callback(text);
    //         }
    //     },
    // });
});

var base_url = window.location.origin;

$(document).tooltip({
    items: ".with-info",
    position: { at: 'left bottom',
        my: 'left top', collision: 'none none' },
    content: function (callback) {
        // callback('Loading...');
        var element = $(this);
        if (element.is(".with-info")) {
            var text = element.attr('data-tags');
            $.ajax({
                url: `${base_url}/api/search-content?tags=${text}`,
            }).done(function(data) {
                callback(data.data.content);
            });
        }
        if (element.is("span.with-tooltip")) {
            var text = element.attr('data-title');
            callback(text);
        }
    },
});

